__turbopack_context__.v({
  "empty": "SingleDemoDayTab-module-scss-module__oWCBKa__empty",
  "showAll": "SingleDemoDayTab-module-scss-module__oWCBKa__showAll",
});
